export {default} from './GroupQualifyingVolume';
